"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombiRplReasonForTestingDtoSpermCountResultEnum = void 0;
exports.CombiRplReasonForTestingDtoSpermCountResultEnum = {
    Normal: 'Normal',
    ResultsPending: 'Results pending',
    AzoospermiaNonObstructive: 'Azoospermia: non-obstructive',
    AzoospermiaObstructive: 'Azoospermia: obstructive',
    AzoospermiaUnknown: 'Azoospermia: unknown',
    Abnormal: 'Abnormal',
    Other: 'Other'
};
